import { useState, useEffect } from 'react';

// Footer réseau My-Monkey — adapté au style paper/ink d'alloc-warrior.
// Données : GET /api/footer?site=<SITE> (stables à la journée, UTM inclus — ne pas réécrire les URL).
// Dégrade silencieusement si l'API est indisponible.
const SITE = 'alloc-warrior.my-monkey.fr';

const COL_LABELS = {
  daily: 'Jeux du jour',
  games: 'Jeux',
  tools: 'Outils',
  maps: 'Cartes',
};

export default function MonkeyFooter() {
  const [net, setNet] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch(`https://git.my-monkey.fr/api/footer?site=${SITE}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive) setNet(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const hasColumns = net?.columns?.length > 0;

  return (
    <footer className="w-full border-t border-dashed border-outline-soft mt-8 pt-5 pb-4 px-4">
      {/* Bandeau marque */}
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <a
            href="https://my-monkey.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="font-display font-bold text-sm text-ink hover:text-stamp-red transition-colors"
          >
            🐵 My-Monkey
          </a>
          <p className="font-sans text-[10px] text-outline mt-0.5">
            La galaxie de jeux &amp; d'outils.
          </p>
        </div>
        <a
          href="https://my-monkey.fr/projets/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-sans text-[10px] text-outline border border-outline-soft px-2 py-1 hover:border-ink hover:text-ink transition-colors"
        >
          Tout l'univers →
        </a>
      </div>

      {/* Colonnes réseau — wrapper réserve l'espace pour éviter le CLS quand le fetch arrive */}
      <div className="min-h-[240px] sm:min-h-[140px] mb-4">
        {hasColumns && (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {net.columns.map((col) => (
              <div key={col.key}>
                <h4 className="font-stamp text-[10px] uppercase tracking-widest text-outline mb-2">
                  {COL_LABELS[col.key] ?? col.label}
                </h4>
                <ul className="space-y-1.5 list-none p-0 m-0">
                  {col.links.map((l) => (
                    <li key={l.url}>
                      <a
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-sans text-[11px] text-ink-soft hover:text-stamp-red transition-colors"
                      >
                        {l.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact — border-t inconditionnel puisque la zone colonnes existe toujours */}
      <div className="font-sans text-[10px] text-outline text-center border-t border-dashed border-outline-soft pt-3">
        Une question, un bug ?{' '}
        <a
          href={`https://my-monkey.fr/?contact=open&project=${SITE}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-brown hover:text-stamp-red underline transition-colors"
        >
          Nous contacter
        </a>
      </div>
    </footer>
  );
}
